import { render, staticRenderFns } from "./ed-viewer-type-object.vue?vue&type=template&id=f871d24e&scoped=true&"
import script from "./ed-viewer-type-object.ts?vue&type=script&lang=ts&"
export * from "./ed-viewer-type-object.ts?vue&type=script&lang=ts&"
import style0 from "./ed-viewer-type-object.scss?vue&type=style&index=0&id=f871d24e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f871d24e",
  null
  
)

export default component.exports